/* This is the EMIS climate Change Component N.9 */

<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <div>
      <table
        style="height: 43px"
        width="800px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 350px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              តើមានការរៀនសូត្រជម្រើសផ្សេង (សម្រាប់ជំនួស)
              ណាមួយទេក្នុងអំឡុងពេលដែលសាលារៀនត្រូវបានបិទមិនដំណើរការ?
            </td>
            <td
              style="
                width: 150px;
                height: 32px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ចម្លើយជ្រើសរើស
            </td>
          </tr>
          <tr v-for="(item, index) in alternative_edu.length" :key="index">
            <td
              style="
                width: 102px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ alternative_edu[index] }}
            </td>
            <td
              style="
                width: 102px;
                height: 32px;
                text-align: center;
                vertical-align: middle;
              "
            >
              <v-select
                class="py-0 px-1"
                v-model="data[index].d"
                :items="yesNo2"
                item-text="text"
                item-value="value"
                outline
                hide-details
                @keypress.native="onSelect($event, index)"
              >
              </v-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { alternative_edu, yesNo2 } from "@/utils/ascf/climateVariables.js";
export default {
  props: ["data", "title"],
  data() {
    return {
      alternative_edu: alternative_edu,
      yesNo2: yesNo2,
    };
  },
  methods: {
    onSelect: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 50) {
        this.data[index].d = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style scoped>
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>